import useApi from '../../../services/useApi'
import {useState} from 'react'

const useSupplierMappingDetailsOperations = () => {
  const Api = useApi()
  const [isLoading, setIsLoading] = useState(false)

  const onAddProducts = (data: any, setError: any) => {
    return Api.post('/suppliers/users/brand/products/mapping', data, {
      successMessage: 'Product added successfully',
      setLoading: setIsLoading,
      setUseFormError: setError,
      refetch: ['user-supplier-mapping','supplier-brands-dropdown'],
    })
  }

  const onDeleteProducts = (data: any) => {
    return Api.delete('/suppliers/users/brand/products/mapping', data, {
      successMessage: 'Product removed successfully',
      setLoading: setIsLoading,
      refetch: ['user-supplier-mapping','supplier-brands-dropdown'],
    })
  }

  return {
    onAddProducts,
    onDeleteProducts,
    isOperationLoading: isLoading,
  }
}
export default useSupplierMappingDetailsOperations
